import { render, staticRenderFns } from "./PhotoStatusBadge.vue?vue&type=template&id=9e2421cc&"
import script from "./PhotoStatusBadge.vue?vue&type=script&lang=js&"
export * from "./PhotoStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./PhotoStatusBadge.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports